import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import {
  DateTimePicker as MUIDateTimePicker,
  type DateTimePickerProps as MUIDateTimePickerProps,
} from "@mui/x-date-pickers/DateTimePicker"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { fr } from "date-fns/locale/fr"

export const DateTimePicker = (props: MUIDateTimePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
      <MUIDateTimePicker
        {...props}
        displayWeekNumber={true}
        sx={{ width: "100%" }}
        slotProps={{
          textField: {
            variant: "outlined",
          },
        }}
      />
    </LocalizationProvider>
  )
}
